// Type for component-specific color extensions
export type ThemeColorExtensions = Partial<Record<string, string>>;

// Base theme color definitions — generic tokens resolved by CSS variables
const themeColors = {
    primary: 'theme-primary',
    primaryBg: 'bg-theme-primary',
    primaryHover: 'hover:bg-theme-secondary',
    primaryHoverClass: 'theme-secondary',
    accent: 'theme-primary',
    accentBg: 'bg-theme-light',
    accentText: 'text-theme-text',
    border: 'border-theme-border',
    headerBg: 'bg-theme-lighter',
    headerHover: 'hover:bg-theme-light',
    iconBg: 'bg-theme-light',
    iconColor: 'text-theme-primary-text',
    topicHover: 'hover:bg-theme-lighter',
    progressBar: 'var(--color-theme-primary)',
    buttonPrimary: 'bg-theme-primary hover:bg-theme-secondary',
    buttonPrimaryFocus: 'focus:ring-theme-primary',
    buttonSecondary: 'text-theme-primary-text hover:bg-theme-light',
    inputFocus: 'focus:border-theme-primary focus:ring-theme-primary/20',
    badgeBg: 'bg-theme-light',
    badgeText: 'text-theme-text',
    hoverText: 'group-hover:text-theme-primary-text',
    gradientFrom: 'from-theme-accent',
    gradientVia: 'via-theme-primary',
    gradientTo: 'to-theme-secondary',
} as const;

// Type for the base theme colors
export type BaseThemeColors = typeof themeColors;

// Combined theme colors type
export type ThemeColors = BaseThemeColors & ThemeColorExtensions;

/**
 * Hook to get theme colors with optional component-specific extensions
 * @param extensions - Optional component-specific color overrides/additions
 * @returns Complete theme color object for current theme
 */
export const useThemeColors = (extensions?: ThemeColorExtensions): ThemeColors => {
    return {
        ...themeColors,
        ...extensions,
    };
};

export default useThemeColors;
